import * as React from "react";
import {ActionEditProps} from "../pluginRegistry";
import {BaseComponent} from "components/BaseComponent/BaseComponent";
import {repository} from "clientInstance";
import {ActionSummaryProps} from "../actionSummaryProps";
import {ActionExecutionLocation} from "../../../client/resources/actionExecutionLocation";
import {ScriptActionEdit, ScriptProperties} from "../script/scriptAction";
import {TargetRoles} from "../../../areas/projects/components/DeploymentProcess/ActionDetails";
import pluginRegistry from "../pluginRegistry";
import {ScriptPackageProperties} from "../script/ScriptPackageReferenceDialog";
import {SupportedLanguage} from "../../ScriptingLanguageSelector/ScriptingLanguageSelector";

class KubernetesRunScriptActionSummary extends BaseComponent<ActionSummaryProps, never> {
    constructor(props: any) {
        super(props);
    }

    render() {
        return <div>
            Run a script within an environment configured using the Kubernetes target.
        </div>;
    }
}

class KubernetesRunScriptActionEdit extends BaseComponent<ActionEditProps<ScriptProperties, ScriptPackageProperties>, never> {
    constructor(props: any) {
        super(props);

    }

    componentDidMount() {
        this.props.doBusyTask(async () => {
            this.setState({
                accounts: await repository.Accounts.all()
            });
        });
    }

    render() {

        return <div>
            {/*<WarningFormSection>*/}
                {/*{this.props.additionalActions && <AzureServerTargetRolesInfo stepTargetRoles={this.props.additionalActions.stepTargetRoles}/>}*/}
                {/*<AzurePowerShellScriptInfo actionType={this.props.plugin.actionType}/>*/}
                {/*<AzurePowerShellAccountInfo accountType={account && account.AccountType}/>*/}
            {/*</WarningFormSection>*/}

            <ScriptActionEdit
                busy={this.props.busy}
                plugin={this.props.plugin}
                projectId={this.props.projectId}
                localNames={this.props.localNames}
                properties={this.props.properties}
                packages={this.props.packages}
                setProperties={this.props.setProperties}
                setPackages={this.props.setPackages}
                doBusyTask={this.props.doBusyTask}
                getFieldError={this.props.getFieldError}
                supportedLanguages={SupportedLanguage.PowerShellAndBash}
                errors={this.props.errors}
                expandedByDefault={this.props.expandedByDefault}/>
        </div>;
    }
}

pluginRegistry.registerDeploymentAction({
    executionLocation: ActionExecutionLocation.AlwaysOnServer,
    actionType: "Octopus.KubernetesRunScript",
    summary: (properties, targetRolesAsCSV) => <KubernetesRunScriptActionSummary properties={properties} targetRolesAsCSV={targetRolesAsCSV} />,
    canHaveChildren: (step) => true,
    canBeChild: true,
    edit: KubernetesRunScriptActionEdit,
    targetRoleOption: (action) => TargetRoles.Required,
    hasPackages: (action) => true,
    features: {
        optional: ["Octopus.Features.SubstituteInFiles", "Octopus.Features.JsonConfigurationVariables",
            "Octopus.Features.ConfigurationTransforms", "Octopus.Features.ConfigurationVariables" ] }
});


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/Actions/kubernetes/kubernetesRunScriptAction.tsx